import * as store from '@daas-consulting/core-frontend-store';
import { StateToken } from '@ngxs/store';
import { context, feature } from '../authentication.const';
import { AuthenticationStateModel as Model } from './authentication.state-model';

const name = store.getName({
  context,
  feature,
  section: 'auth',
});
export const stateTokenName = new StateToken<Model>(name);
